import { useMemo } from 'react';
import { match, P } from 'ts-pattern';
import useWindowDimensions from '../useWindowDimensions';
import useIsMounted from '../useIsMounted';
const breakpoints = {
    mobile: 300,
    tablet: 760,
    laptop: 992,
    desktop: 1200,
    'large-desktop': 1500,
};
const useBreakpoints = (serverSideDefault = 'mobile') => {
    const { width } = useWindowDimensions();
    const isMounted = useIsMounted();
    const breakpoint = useMemo(() => {
        if (!isMounted)
            return serverSideDefault;
        return match(width)
            .with(P.when((w) => w < breakpoints.tablet), () => 'mobile')
            .with(P.when((w) => w < breakpoints.laptop), () => 'tablet')
            .with(P.when((w) => w < breakpoints.desktop), () => 'laptop')
            .with(P.when((w) => w < breakpoints['large-desktop']), () => 'desktop')
            .otherwise(() => 'large-desktop');
    }, [isMounted, serverSideDefault, width]);
    return breakpoint;
};
export default useBreakpoints;
//# sourceMappingURL=index.js.map